import type { Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const QuoteCostDetailsStyle: StyleExtend<Theme> = {
  flex: 3,
  alignItems: { xs: 'start', md: 'center' },
  gap: {
    xs: '.125rem',
    md: '.5rem',
  },
};

export const QuoteCostDetailsFullStyle: StyleExtend<Theme> = {
  color: (theme) => theme.palette.customColors.darkGray,
};
